const estimatedQualities = new Set(['street-estimate', 'origin-reference', 'house-unverified', 'nearby-house-estimate']);
export const MIN_ORIGIN_REFERENCE_MOVEMENT_METERS = 20;

export const checkoutMapDistanceMeters = (left, right) => {
  if (!left || !right || !Number.isFinite(Number(left.lat)) || !Number.isFinite(Number(left.lng))
    || !Number.isFinite(Number(right.lat)) || !Number.isFinite(Number(right.lng))) return 0;
  const radians = (value) => Number(value) * Math.PI / 180;
  const dLat = radians(Number(right.lat) - Number(left.lat));
  const dLng = radians(Number(right.lng) - Number(left.lng));
  const a = Math.sin(dLat / 2) ** 2 + Math.cos(radians(left.lat)) * Math.cos(radians(right.lat)) * Math.sin(dLng / 2) ** 2;
  return 6371000 * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
};

export const getCheckoutMapPrecisionState = (initialQuality = 'origin-reference', userAdjusted = false, movementMeters = 0,
  allowPrepositionedConfirmation = false) => {
  const quality = String(initialQuality || 'origin-reference');
  const requiresOriginMovement = quality === 'origin-reference';
  const isEstimate = estimatedQualities.has(quality);
  const requiresPinMovement = isEstimate && (!allowPrepositionedConfirmation || requiresOriginMovement);
  const movedAwayFromOrigin = !requiresOriginMovement || movementMeters >= MIN_ORIGIN_REFERENCE_MOVEMENT_METERS;
  const canConfirm = !requiresPinMovement || (userAdjusted && movedAwayFromOrigin);
  const label = isEstimate && userAdjusted && canConfirm
    ? 'Pino ajustado manualmente'
    : quality === 'official-address-point'
      ? 'Número localizado na base oficial'
      : quality === 'nearby-house-estimate'
        ? 'Local da entrega'
        : quality === 'house'
          ? 'Número localizado no mapa'
          : quality === 'gps'
            ? 'Localização do aparelho'
            : quality === 'saved-confirmed'
              ? 'Ponto confirmado anteriormente'
      : canConfirm ? 'Ponto pronto para confirmação' : 'Local da entrega';
  return {
    requiresPinMovement,
    canConfirm,
    label,
    message: !requiresPinMovement || canConfirm ? ''
      : requiresOriginMovement && userAdjusted
        ? `O pino ainda está na loja. Mova-o pelo menos ${MIN_ORIGIN_REFERENCE_MOVEMENT_METERS} metros até a entrada da entrega.`
        : 'Marque a entrada da entrega no mapa para continuar.',
  };
};
